import * as Actions from '../actions/index';

export default function sources(
  state = {
    pendingActions: {},
  },
  action,
) {
  switch (action.type) {
    case Actions.LOAD_PENDING_ACTIONS: {
      return {
        ...state,
        pendingActions: {
          ...state.pendingActions,
          [`${action.entityId}:${action.entityType}`]:
            action.pendingActions || [],
        },
      };
    }
    default:
      return state;
  }
}
